import { cancelledBookings } from '@assets/icons'
import Table from '@components/table'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@store'
import { useModal } from '@context/ModalContext'
import { Booking, Config, Transaction } from '@apis'
import Button from '@components/button'
import { Helper } from '@utils'
import UserProfile from '@components/userprofile'
import { useNavigate } from 'react-router-dom'
import Typography from '@components/typography'
import { Form, Formik } from 'formik'
import Column from '@components/column'
import Fields from '@components/fields'
import Row from '@components/row'
import theme from '@utils/theme'

const PendingRefund = () => {
  const {
    items: bookings = [],
    loading,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.transaction)
  const { data: config } = useSelector((state: RootState) => state.config)
  const [page, setPage] = useState(1)
  const { showModal } = useModal()
  const fetchPendingTransactions = async () => {
    const params: any = {
      status: 'Pending Refund',
      page,
      limit: 20,
      withUser: true,
    }

    await Transaction.list({ state: 'transaction', params })
      .then(() => {})
      .catch(() => {})
  }

  const fetchConfig = async () => {
    await Config.list({ state: 'config' })
  }
  useEffect(() => {
    fetchPendingTransactions().then(() => {})
    fetchConfig().then(() => {})
  }, [])

  const columns = [
    {
      title: 'Booking Id',
      key: 'bookingId',
      render: (item: any) => <>{item?.booking?.id}</>,
    },
    {
      title: 'User Detail',
      key: 'userDetail',
      render: (item: any) => <UserProfile item={item.user} />,
    },
    {
      title: 'Travel Route',
      key: 'travelRoute',
      render: (item: any) => (
        <>
          <p>{item?.booking?.schedule?.route?.departure?.name}</p>
          <p>{item?.booking?.schedule?.route?.destination?.name}</p>
        </>
      ),
    },
    {
      title: 'Refund Amount',
      key: 'refundAmount',
      render: (item: any) => (
        <>
          {Number(item.amount) -
            (config?.cancellationCharge?.cancellationPercent / 100) *
              item.amount}
        </>
      ),
    },
    {
      title: 'Cancel Date',
      key: 'cancelDate',
      render: (item: any) => (
        <>
          <p>{Helper.formatDate(item?.infos?.cancelledDate)}</p>
          <p>{Helper.formatTime(item?.infos?.cancelledDate)}</p>
        </>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (item: any) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            title={'Add Refund'}
            onClick={() => {
              showModal(<CancellationStatusUpdateModal item={item} />)
            }}
          />
        </div>
      ),
    },
  ]
  return (
    <Table
      columns={columns}
      data={bookings}
      text="Pending Refunds"
      icon={cancelledBookings}
      totalItems={totalItems}
      totalPages={totalPages}
      loading={loading}
      itemsPerPage={20}
      pageControlled={page}
      onPageChange={setPage}
    />
  )
}

export default PendingRefund

const CancellationStatusUpdateModal = ({ item }) => {
  const { data: config } = useSelector((state: RootState) => state.config)
  const navigate = useNavigate()
  const [initialValue, setInitialValue] = React.useState({
    amount:
      Number(item.amount) -
      (config?.cancellationCharge?.cancellationPercent / 100) * item.amount,
    receipt: '',
  })
  const { showModal, hideModal } = useModal()
  const handleRefundNow = async (values) => {
    const payload = {
      receipt: {
        base64: values.receipt.base64,
        extension: values.receipt.extension,
      },
    }
    await Transaction.refundStatus({
      state: 'transactions',
      id: item.id,
      data: payload,
    }).then(() => {
      hideModal()
      window.location.reload()
    })
    hideModal()
  }

  const fetchConfig = async () => {
    await Config.list({ state: 'config' })
  }
  useEffect(() => {
    fetchConfig().then(() => {})
  }, [])
  return (
    <>
      <Typography color={'primary'} align={'center'} size={20}>
        Cancellation Request
      </Typography>
      <Formik initialValues={initialValue} onSubmit={handleRefundNow}>
        <Form>
          <Column>
            <Fields.Input
              name={'amount'}
              label={'Refund Amount'}
              disabled={true}
            />

            <Fields.Upload name={'receipt'} label={'Upload Receipt'} />
          </Column>
          <br />
          <Row styleRow="justify-content:center">
            <Button title="Provide Refund" type="submit" />

            <Button
              title="Provide Refund Later"
              type="submit"
              styleButton={`color:${theme.colors.red};background:transparent;border:1px solid ${theme.colors.red}`}
              onClick={async () => {
                hideModal()
              }}
            />
          </Row>
        </Form>
      </Formik>
    </>
  )
}
